import * as dataStore from './DataStore';
import StoryMixerCategory from '../models/StoryMixerCategory';
import StoryMixerTerm from '../models/StoryMixerTerm';
import GetStoryElementsByIsbnUrlBuilder from '../lib/dataRetrieval/GetStoryElementsByIsbnUrlBuilder';
import { attachFunctionToCallback } from '../utility';
import { getPrimaryIsbn } from "../data/TitleInfoSelector";
import { performJsonpGetRequest } from "../lib/HttpRequest";
import SearchByStoryElementsUrlBuilder from 'lib/titleSearch/storyElements/SearchByStoryElementsUrlBuilder';

const getStoryElementResultCallbackName = "getStoryElementResultCallback";
const getTitlesBySelectedTermsCallbackName = "getTitlesBySelectedTermsCallback";

export function getStoryMixerCategories() {
	let storyMixerCategoryResult = [];
	let getStoryElementsResult = dataStore.getStoryElementsResult();
	if (getStoryElementsResult) {
		let storyMixerElementList = getStoryElementsResult.storyElements;
		if (storyMixerElementList) {
			let categoryList = [];
			storyMixerElementList.forEach(element => {
				if (categoryList.indexOf(element.category) < 0) {
					categoryList.push(element.category);
				}
			});

			categoryList.forEach(category => {
				let categoryTermList = storyMixerElementList.filter(term => term.category === category)
					.map(term => new StoryMixerTerm(term));
				storyMixerCategoryResult.push(new StoryMixerCategory({ name: category, termList: categoryTermList }));
			});
		}
	}
	return storyMixerCategoryResult.sort(function(a,b) {
		return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
	});

}

export function getStoryMixerAppealTerms(postAction){
	let profileData = dataStore.getProfileData();
	const doesProfileHaveAppeals = profileData && profileData.FeatureSettings && profileData.FeatureSettings.hasOwnProperty('appeals');
	if (doesProfileHaveAppeals){
		let isbn = getPrimaryIsbn(dataStore.getJsonData());
		let url = new GetStoryElementsByIsbnUrlBuilder().generateUrl(profileData, isbn);
	
		attachFunctionToCallback(
			postAction,
			getStoryElementResultCallbackName
		);
		performJsonpGetRequest(url, getStoryElementResultCallbackName);
	}
}

export function getTitlesBySelectedTermsforV4(searchValues, callback){
	let titleInfo = dataStore.getJsonData().TitleInfo;
	let profileData = dataStore.getProfileData();
	let url = new SearchByStoryElementsUrlBuilder().generateUrl(
		titleInfo.ui,
		searchValues,
		profileData
	);

	attachFunctionToCallback(
		callback,
		getTitlesBySelectedTermsCallbackName
	);

	performJsonpGetRequest(url, getTitlesBySelectedTermsCallbackName);
}






// WEBPACK FOOTER //
// ./src/data/StoryMixerSelector.js